import useSWRImmutable from 'swr/immutable'

import { useApis } from '../contexts/api-context'
import { USER_TYPE } from '../redux/UserRedux'
import { type ClientType } from '../types/ClientStateType'
import useUser from './useUser'

const fetchFunction = async (api): Promise<ClientType[]> => {
  const res = await api.getAllClients()
  return res.data
    .sort((a, b) => (a.lastName || '').localeCompare(b.lastName))
    .sort((a, b) => (a.firstName || '').localeCompare(b.firstName))
}

const useClients = () => {
  const { api } = useApis()
  const { user } = useUser()
  const { data, mutate: refetchClients } = useSWRImmutable(
    user?.type === USER_TYPE.THERAPIST ? 'useClients' : null,
    () => fetchFunction(api),
  )

  return { clients: data, refetchClients }
}

export default useClients
